import ServiceItemDashboard from "../service/ServiceItemDashboard";
import {Stack, Container, Typography, Button} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import { useNavigate } from 'react-router-dom';

const ServiceAdvice = ({data}) => {
    const {mode} = useDarkMode();
    const navigate = useNavigate();
    return (

        <Container className={'wrap-container'} style={{paddingBottom: 20}} id={"service"}>
            <Stack gap={5} >
                <Typography variant={'h2'} style={{color : mode.settings.textColor3}}>Des exemples de services et conseils que vous pourrez retrouver</Typography>
                <Stack direction={"row"} justifyContent={{xs : 'center' , md : 'center' , lg : 'space-between'}} style={{gap: 50}} flexWrap={"wrap"}>
                    <ServiceItemDashboard
                        type={"Service"}
                        image={"/assets/img/Livraison courseservices-illustration.png"}
                        title={'Livraison de courses'}
                        color={'#C72B5C'}
                        icon={"/assets/icon/service-red.png"}
                        iconTitle={"/assets/icon/service-icon.png"}
                        flip={true}
                        detail={""}
                        description={"Nous vous livrons vos courses commandées sur le Drive de votre magasin préféré."}
                    />
                    <ServiceItemDashboard
                        type={"Service"}
                        image={"/assets/img/Jardinageservices-illustration.png"}
                        title={'Petits travaux de jardinage'}
                        color={'#C72B5C'}
                        icon={"/assets/icon/service-red.png"}
                        iconTitle={"/assets/icon/service-icon.png"}
                        description={"Nous nous chargeons de l’entretien de votre jardin, de votre potager, de votre terrasse et de vos haies."}
                    />
                    <ServiceItemDashboard
                        type={"Service"}
                        image={"/assets/img/garde animauxservices-illustration.png"}
                        title={'Garde d’animaux '}
                        color={'#C72B5C'}
                        icon={"/assets/icon/service-red.png"}
                        iconTitle={"/assets/icon/service-icon.png"}
                        description={"Nous nous occupons de votre animal de compagnie chez vous ou en pension pendant vos vacances ou hospitalisation."}
                    />
                    <ServiceItemDashboard
                        type={"Conseil"}
                        image={"/assets/img/Cours informatiqueservices-illustration.png"}
                        title={'Cours d’informatique'}
                        color={'#6D7C84'}
                        icon={"/assets/icon/advice-grey.png"}
                        iconTitle={"/assets/icon/advice-icon.png"}
                        flip={true}
                        description={"Développer vos compétences en informatique et devenez autonome avec votre tablette, ordinateur ou smartphone.  "}
                    />
                    <ServiceItemDashboard
                        type={"Service"}
                        image={"/assets/img/Petit bricolageservices-illustration.png"}
                        title={'Petit bricolage'}
                        color={'#C72B5C'}
                        icon={"/assets/icon/service-red.png"}
                        iconTitle={"/assets/icon/service-icon.png"}
                        description={"Nous pouvons réaliser de petits travaux chez vous (pose de tringle, fixer une étagère, monter un meuble…)"}
                    />
                    <ServiceItemDashboard
                        type={"Service"}
                        image={"/assets/img/Transport adaptéservices-illustration.png"}
                        title={'Transport adapté'}
                        color={'#C72B5C'}
                        icon={"/assets/icon/service-red.png"}
                        iconTitle={"/assets/icon/service-icon.png"}
                        description={"Vous souhaitez vous déplacer chez le coiffeur ou pour un rendez-vous médical ? Nous vous emmenons."}
                    />
                </Stack>
                <Stack alignItems={"center"}>
                    <Button
                        className="btn-gradient"
                        sx={{
                            width : {xs: 270, md: 400,lg : 400}
                        }}
                        onClick={() => navigate('registration')}
                    >
                        <Typography variant={'subtitle3'} color={'white'}>
                            Je m'inscris pour profiter de ces services
                        </Typography>
                    </Button>
                </Stack>
            </Stack>
        </Container>
    )
}

export default ServiceAdvice;
